export default `
query isQuoteCartEnabled {
  isQuoteCartEnabled
}
`;
